import { useTranslation, useLocation, Link } from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as LocaleContext from "../../i18n/I18nProvider.jsx";
import * as AnalyticsContext from "../../analytics/AnalyticsProvider.jsx";
import * as UseMediaQueryModule from "../../hooks/useMediaQuery.js";
import * as React from "react";
import * as EcosystemComponents from "../EcosystemGrid.jsx";
import { sectionClass } from "../../config/sectionClasses.js";
import { Reveal } from "../Reveal.jsx";
import { sectionHeaderClass } from "../../config/sectionClasses.js";
import * as LocalizedPathsModule from "../../routing/localizedPaths.js";
function Ecosystem() {
  let { t: translate } = useTranslation(),
    { language: language } = (0, LocaleContext.useI18n)(),
    { pathname: pathname } = useLocation(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    r = (0, UseMediaQueryModule.useMediaQuery)("(max-width: 767px)"),
    l = (0, React.useRef)(null),
    s = r
      ? [
          ...EcosystemComponents.ecosystemApps,
          ...EcosystemComponents.ecosystemApps,
          ...EcosystemComponents.ecosystemApps,
        ]
      : EcosystemComponents.ecosystemApps;
  return (
    (0, React.useEffect)(() => {
      let e = l.current;
      if (!r || !e) return;
      let t = e.children[0],
        i = e.children[EcosystemComponents.ecosystemApps.length],
        n = t && i ? i.offsetLeft - t.offsetLeft : 0;
      if (n <= 0) return;
      let o = 0,
        a = performance.now(),
        s = e.scrollLeft,
        c = 24,
        d = true;
      (s < n && (s += n), (e.scrollLeft = s));
      let u = s,
        p = new IntersectionObserver(
          ([e]) => {
            d = e.isIntersecting;
          },
          {
            rootMargin: "120px",
          },
        );
      p.observe(e);
      let m = (t) => {
        o = requestAnimationFrame(m);
        let i = Math.min(t - a, 100) / 1e3;
        if (((a = t), !(!d || e.contains(document.activeElement)))) {
          if (Math.abs(e.scrollLeft - u) > 1.5) {
            ((u = s = e.scrollLeft), (c = 0));
            return;
          }
          if (c < 24) {
            c += 1;
            return;
          }
          ((s += 50 * i) >= 2 * n ? (s -= n) : s < n && (s += n),
            (e.scrollLeft = s),
            (u = s));
        }
      };
      return (
        (o = requestAnimationFrame(m)),
        () => {
          (cancelAnimationFrame(o), p.disconnect());
        }
      );
    }, [r]),
    (
      <section className={`${sectionClass} Home_ecosystemSection__0iuvX`}>
        <Reveal>
          <div className={sectionHeaderClass}>
            <h2>{translate("home.ecosystem.title")}</h2>
          </div>
        </Reveal>
        <div ref={l} className={"Ecosystem_ecosystemGrid__JUG0s"}>
          {s.map((e, a) => {
            let r = Math.floor(a / EcosystemComponents.ecosystemApps.length),
              l = r > 0,
              u = (0, LocalizedPathsModule.BC)(e.href, pathname, language),
              f = () =>
                track("track", "home_agent_click", {
                  title: e.name,
                }),
              h = (
                <React.Fragment>
                  <img
                    src={e.iconSrc}
                    alt={""}
                    className={"Ecosystem_ecosystemIcon__JUG0s"}
                    aria-hidden={"true"}
                    loading={"lazy"}
                  />
                  {e.name}
                </React.Fragment>
              );
            return (
              <Reveal key={l ? `${e.id}-${r}` : e.id} delay={0.04 * a}>
                {/^https?:\/\//u.test(e.href) ? (
                  <a
                    href={e.href}
                    className={"Ecosystem_ecosystemItem__JUG0s"}
                    aria-hidden={l || undefined}
                    tabIndex={l ? -1 : undefined}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    onClick={f}
                  >
                    {h}
                  </a>
                ) : (
                  <Link
                    to={u}
                    className={"Ecosystem_ecosystemItem__JUG0s"}
                    aria-hidden={l || undefined}
                    tabIndex={l ? -1 : undefined}
                    onClick={f}
                  >
                    {h}
                  </Link>
                )}
              </Reveal>
            );
          })}
        </div>
      </section>
    )
  );
}
export { Ecosystem };
